var generateStyle = function generateStyle(componentTheme) {
  return {
    headerButtonsContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
      flexWrap: 'wrap',
      gap: componentTheme.headerButtonsGap
    }
  };
};
export default generateStyle;